module.exports = function reducer_EntryPoints(state = []) {
    return state;
};
